import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("label", { class: "form-label small" }, "Dimensione (cm)", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "form-control form-control-sm",
        type: "number",
        step: "0.01",
        min: "0",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tempSize) = $event))
      }, null, 512), [
        [
          _vModelText,
          _ctx.tempSize,
          void 0,
          { number: true }
        ]
      ])
    ])
  ]))
}